import React from 'react';
import { useAuthStore } from 'src/store/auth';

import { DONE_COPY } from '../constants/copy';
import { W2_SELECT_TID } from '../constants/testids';
import { TerminalThankYou } from '../../components/TerminalThankYou';

const TID = W2_SELECT_TID.done;

/**
 * Terminal confirmation (client copy, screen 11): "Thank you, {Firstname}!" +
 * portal-access / cards-coming message, in the `/thanks`-page layout (full-width
 * card + waving-man image, via the shared `TerminalThankYou`). Rendered inside
 * the selection scaffold (all step-bar cells completed) after a successful
 * signature — and also when the flow is re-entered already locked (a returning,
 * already-signed employee).
 */
export const SelectionDone: React.FC<{ alreadyLocked?: boolean }> = ({
  alreadyLocked = false,
}) => {
  const firstName = useAuthStore((s) => s.user?.firstName);
  const headline = DONE_COPY.headline(firstName?.trim() || 'there');

  return (
    <TerminalThankYou
      testids={TID}
      headline={headline}
      body={DONE_COPY.body}
      footnote={
        alreadyLocked
          ? 'Your elections are already signed and locked in. Need a change? Contact your benefits team and they can reopen your selection.'
          : undefined
      }
    />
  );
};
